var React = require('react');

function LoveIconInline (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M9.9402 3.17974C10.7474 1.30813 12.5915 0.000391304 14.7363 0.000391304C17.6256 0.000391304 19.7064 2.41826 19.968 5.29983C19.968 5.29983 20.1092 6.01513 19.7984 7.30291C19.3752 9.05674 18.3804 10.6149 17.0391 11.8041L9.9402 18L2.96086 11.8037C1.61963 10.6149 0.624813 9.05635 0.201605 7.30252C-0.109201 6.01474 0.0320015 5.29943 0.0320015 5.29943C0.293607 2.41787 2.37445 0 5.26371 0C7.40895 0 9.13298 1.30813 9.9402 3.17974Z","fill":"#FF3D2E"}));
}

LoveIconInline.defaultProps = {"width":"20","height":"18","viewBox":"0 0 20 18","fill":"none"};

module.exports = LoveIconInline;

LoveIconInline.default = LoveIconInline;
